import ArrowLeftIcon from "@assets/icons/arrowLeft"
import ArrowSquareLeftIcon from "@assets/icons/arrowSquareLeft"
import AddPatientForm from "./AddPatientForm"
import { Link } from "react-router-dom"
const AddPatient = () => {
  return (
    <div className="flex flex-col gap-10 md:gap-16">
      <div className="flex flex-col gap-2">
        <Link to={"/manage-patient-vision"} className="md:hidden mb-5">
          <ArrowSquareLeftIcon />
        </Link>
        <div className="flex gap-3 items-center">
          <Link to={"/manage-patient-vision"} className="hidden md:block">
            <ArrowLeftIcon width="16" height="16" />
          </Link>
          <div className="text-xs text-[--primary-blue]">
            Manage patient {">"} Add new patient
          </div>
        </div>

        <h1 className="text-3xl 3xl:text-4xl text-[--primary-blue]">
          Add patient
        </h1>
        <p className="text-sm text-[--text-light-gray] font-medium">
          Fill out the details to register the patient to manage reports and
          plan
        </p>
      </div>

      <div className="p-0 md:p-8 gap-8 flex flex-col items-center md:items-start relative min-h-[25rem] rounded-2xl md:bg-[--pure-white] overflow-y-scroll no-scrollbar">
        <AddPatientForm />
        <Link
          to={"/manage-patient-vision/add-registered-patient"}
          className="text-sm text-[--primary-blue] font-bold tracking-widest underline"
        >
          OR ADD REGISTERED PATIENT
        </Link>
      </div>
    </div>
  )
}

export default AddPatient
